import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import './OfflineRead.css';
import '../Ebook/Read.css';
import moment from 'moment-timezone';
import Header from '../Header/Header';
import { Modal } from "react-bootstrap";
import { Nav, Navbar } from "react-bootstrap";
import { NavDropdown } from 'react-bootstrap';
import CopyToClipboard from "react-copy-to-clipboard";
import { makeStyles } from '@material-ui/core/styles';
import shareLinkIcon from '../Ebook/shareLinkIcon.png';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import PrimitivoHighlighter from '../MyTextHighlighter/highlighters/primitivo';
import { Typography, Popper, ClickAwayListener, Fade, Paper } from '@material-ui/core';
import {
    getUserSettings, getChaptersList, getChapterContentAndImages, getUserBookDetails,
    getChapterHighlights, getChapterProfLinks, offlineRead
} from '../../app/models/db';
const useStyles = makeStyles(() => ({ root: { width: 500, } }));
export function OfflineRead() {
    const { userId, isbn, chapterid } = useParams();
    const classes = useStyles();
    let selection = "";
    let selectedNoteId = "";
    let selectionElement = "";
    let selectedNoteIdlink = "";
    let saveActivityTimer = null;
    let enclosingParaIdString = "";
    const copyId = 'simple-copyPopover';
    const reactNode = process.env.REACT_APP_NODE_NAME;
    const contFontSize = localStorage.getItem("userBookFontSize") ? localStorage.getItem("userBookFontSize") : "14";
    const contLineHeight = localStorage.getItem("userBookLineHeight") ? localStorage.getItem("userBookLineHeight") : "12";
    const idbDetails = { bookISBN: isbn, userId: userId };
    const [userVO, setUserVO] = useState(null);
    const [anchorEl, setAnchorEl] = useState("");
    const [profLink, setProflink] = useState("");
    const [noteValue, setNoteValue] = useState("");
    const [showLink, setShowLink] = useState(true);
    const [copiedText, setCopiedText] = useState("");
    const [bookDetails, setBookDetails] = useState();
    const [noDownlMsg, setNoDownlMsg] = useState("");
    const [placement, setPlacement] = useState('bottom');
    const [placementUpdate, setPlacementUpdate] = useState();
    const [downlSelChapter, setDownlSelChapter] = useState();
    const [anchorElUpdate, setAnchorElUpdate] = useState("");
    const [copySelectedText, setCopySelectedText] = useState();
    const [downlChapterList, setDownlChapterList] = useState([]);
    const [downlSelChapCont, setDownlSelChapCont] = useState();
    const [isNavSubMenuOpen, setIsNavSubMenuOpen] = useState(false);
    const [showNextChapterLink, setShowNextChapterLink] = useState(false);
    const [isPopoverOpenUpdate, setIsPopoverOpenUpdate] = useState(false);
    const [isCopyOnlyPopoverOpen, setIsCopyOnlyPopoverOpen] = useState(false);
    const [noChaptDownlError, setNoChaptDownlError] = useState({ popStatus: false, popMsg: "" });
    useEffect(async () => {
        let bookDetails = await getUserBookDetails(`CC_ISBN|${isbn}`, idbDetails);
        setBookDetails(bookDetails);
        let downloadedChapters = await getChaptersList(idbDetails);
        if (!downloadedChapters && !downloadedChapters.length > 0) {
            setNoDownlMsg("This link is not currently available offline. Please connect to the internet, log in to your Casebook Connect account, and ensure you’ve saved this title for offline use in this browser.")
            return false;
        }
        const downloadedChapter = downloadedChapters[0], downloadedChapterHtmlLoc = downloadedChapter.pageHtmlLocation;
        handleChapterSelection(downloadedChapterHtmlLoc ? downloadedChapter : (downloadedChapter.subChapters && downloadedChapter.subChapters[0]));
        downloadedChapters.map(downlChapt => { if (downlChapt.subChapters) { downlChapt.chariot_down_status = false } });
        setDownlChapterList(downloadedChapters);
        let userVO = await getUserSettings(`userVO`, { userId, isbn });
        setUserVO(userVO);
    }, []);
    useEffect(() => {
        if (downlSelChapCont) {
            setContetntFontStylings();
            var myDiv = document.querySelector("#offlineReader-bookContentContainer");
            if (downlSelChapCont.length > 0 && myDiv.scrollHeight == myDiv.offsetHeight) {
                setShowNextChapterLink(true);
            }
        }
        $(".fa-comment").click(function () {
            alert($(this).prev().text());
        })
    }, [downlSelChapCont]);
    // When user read book insert record into index db.
    useEffect(() => {
        let currentTime = moment().format();
        offlineRead.add(isbn, userId, currentTime);
    }, [])
    const setContetntFontStylings = () => {
        let contentClass = "#offlineReader-bookContentContainer";
        let contentFontSize = (contFontSize < 12) ? "14px" : contFontSize + "px", contentLineHeight;
        if (contLineHeight <= "12") contentLineHeight = "1.2";
        else if (contLineHeight === "15") contentLineHeight = "1.8";
        else if (contLineHeight === "20") contentLineHeight = "2.4";
        $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
        $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": contentFontSize, "line-height": contentLineHeight });
        $(contentClass).find(".cc-font-xsmall p").css("font-size", contentFontSize);
        $(contentClass).find(".cc-font-xsmall").css("font-size", contentFontSize);
        if (contFontSize === "12") {
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "11px");
            $(contentClass).find(".cc-font-small p").css("font-size", "14px");
            $(contentClass).find(".cc-font-small").css("font-size", "14px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large").css({ "font-size": "14px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "22px", "line-height": contentLineHeight });
        } else if (contFontSize === "14") {
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "12px");
            $(contentClass).find(".cc-font-small p").css("font-size", "16px");
            $(contentClass).find(".cc-font-small").css("font-size", "16px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large").css({ "font-size": "16px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "18px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "18px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "18px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "24px", "line-height": contentLineHeight });
        } else if (contFontSize === "16") {
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "14px");
            $(contentClass).find(".cc-font-small p").css("font-size", "18px");
            $(contentClass).find(".cc-font-small").css("font-size", "18px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large").css({ "font-size": "22px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "30px", "line-height": contentLineHeight });
        } else if (contFontSize === "18") {
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "16px");
            $(contentClass).find(".cc-font-small p").css("font-size", "22px");
            $(contentClass).find(".cc-font-small").css("font-size", "22px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large").css({ "font-size": "24px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "36px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "36px", "line-height": contentLineHeight });
        } else if (contFontSize === "20") {
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "18px");
            $(contentClass).find(".cc-font-small p").css("font-size", "24px");
            $(contentClass).find(".cc-font-small").css("font-size", "24px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-large").css({ "font-size": "30px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "36px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "36px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "36px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "42px", "line-height": contentLineHeight });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "42px", "line-height": contentLineHeight });
        }
    }
    const handleChapterSelection = async (selChapter, pageNum, selChapterId) => {
        let selectedChapterId;
        if (selChapter.pageHtmlLocation) {
            pageNum = pageNum ? pageNum : (selChapter.chapterStartPageNumber);
            let selChaptersCont = await getChapterContentAndImages((selChapter.pageHtmlLocation).split('?')[0], idbDetails)
                .then(response => response.text()).then(html => { return html; }).catch(err => {
                    return false;
                });
            if (!selChaptersCont) {
                setNoChaptDownlError({ popStatus: true, popMsg: "Error: Chapter is not downloaded properly. Please download the chapter in online and try Again!!!" });
                return false;
            }
            setNoDownlMsg("");
            setDownlSelChapter(selChapter);
            selectedChapterId = (selChapter.chapterId);
            handleBrowserUrl(selectedChapterId, pageNum);
            setDownlSelChapCont(selChaptersCont.split("<body>")[1].replace(/<body>|<\/body>|<\/html>/g, "").replace(/<\s*([^\s>]+)([^>]*)\/\s*>/g, "<$1$2><\/$1>"));
            await updateImageURL(selChapterId ? selChapterId : selectedChapterId);
            document.querySelector('#notes-container').innerHTML = '';
            document.querySelector('#links-container').innerHTML = '';
            getAndUpdateHighlightOneBook(selectedChapterId);
            getAndUpdateChapterProfLinkOneBook(selectedChapterId);
            var docPageNumb = document.getElementById(`page-${pageNum}`);
            if (docPageNumb && docPageNumb.scrollIntoView) { docPageNumb.scrollIntoView(); }
        }
    }
    const handleBrowserUrl = (browserChaptId, browserPageNum) => {
        let isRomanNumber = false, newBrowserUrl;
        const romanNumeralRegex = /^(M{0,3})(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/i;
        if (romanNumeralRegex.test(browserPageNum)) { isRomanNumber = true; }
        if (browserChaptId) {
            newBrowserUrl = `/cc/read/users/${userId}/books/${isbn}/${browserChaptId}${(!isRomanNumber ? ("#page-" + browserPageNum) : "")}`;
            window.history.replaceState("", "", newBrowserUrl);
        } else {
            newBrowserUrl = `/${reactNode}/read/users/${userId}/books/${isbn}/${chapterid}${(!isRomanNumber ? ("#page-" + browserPageNum) : "")}`;
            window.history.replaceState("", "", newBrowserUrl);
        }
    }
    const handleChapterChariotDown = (selChapterData, selType, selcChapterChariotStatus) => {
        let selectedChapterId = selChapterData.chapterId;
        if (selType === 'chapterName' && selChapterData.pageHtmlLocation) {
            handleChapterSelection(selChapterData, undefined, selectedChapterId);
        }
        const newSelChaptState = downlChapterList && downlChapterList.map((chapt) => {
            if (chapt.chapterId === selectedChapterId) { chapt.chariot_down_status = selcChapterChariotStatus; }
            else if (chapt.subChapters) { chapt.chariot_down_status = false; }
            return chapt;
        });
        setDownlChapterList(newSelChaptState);
    }
    const updateImageURL = async (selChapterId) => {
        const offlineContainer = document.getElementById('offlineReader-ereaderContainer');
        let imgs = offlineContainer.querySelectorAll('img'), imgSrc, imgBlob, imgObjUrl;
        if (imgs.length > 0) {
            for (let i = 0; i < imgs.length; i++) {
                imgSrc = imgs[i].getAttribute('src');
                imgBlob = await getChapterContentAndImages((`${selChapterId}|${imgSrc}`), idbDetails);
                if (imgBlob) {
                    imgObjUrl = URL.createObjectURL(await imgBlob);
                    imgs[i].src = imgObjUrl;
                }
            };
        }
    }
    const handleScroll = () => {
        let myDiv = document.querySelector("#offlineReader-bookContentContainer");
        if (myDiv.offsetHeight + myDiv.scrollTop >= myDiv.scrollHeight - 1000) {
            setShowNextChapterLink(true);
        } else {
            setShowNextChapterLink(false);
        }
        let pagNumb;
        let Txtpage = document.querySelectorAll(".cc-pagenum-begin");
        if (Txtpage != 'undefined' && Txtpage != null) {
            Array.from(Txtpage).forEach(e => {
                if (checkVisible(e)) {
                    pagNumb = e.innerHTML.replace('p', '').replace('.', '').trim();
                }
                return false;
            });
        }
        if (saveActivityTimer) { clearTimeout(saveActivityTimer); }
        saveActivityTimer = setTimeout(
            function () {
                let Txtpage = document.querySelectorAll(".cc-pagenum-begin");
                if (Txtpage != 'undefined' && Txtpage != null) {
                    if (pagNumb) { handleBrowserUrl(undefined, pagNumb); }
                }
            }.bind(this), 1000
        );
    };
    const checkVisible = (elm) => {
        let rect = elm.getBoundingClientRect();
        let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }
    const navigateToPage = (pageNumber) => {
        let isRomanNumber = false, isNormalNumber = false;
        const romanNumeralRegex = /^(M{0,3})(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/i;
        if (romanNumeralRegex.test(pageNumber)) { isRomanNumber = true; }
        const normalNumberRegex = /^[0-9]+$/;
        if (normalNumberRegex.test(pageNumber)) { isNormalNumber = true; }
        let isPageNumberFound = null, isPageNumberChapter = null;
        downlChapterList.forEach((chapter) => {
            if (isRomanNumber) {
                if (chapter.subChapters) {
                    chapter.subChapters.map(subChapter => {
                        if (subChapter.chapterStartPageNumber === pageNumber) {
                            isPageNumberChapter = subChapter;
                            isPageNumberFound = pageNumber;
                            return;
                        }
                    });
                    if (chapter.pageHtmlLocation && chapter.chapterStartPageNumber === pageNumber) {
                        isPageNumberChapter = chapter;
                        isPageNumberFound = pageNumber;
                        return;
                    }
                } else if (chapter.chapterStartPageNumber === pageNumber) {
                    isPageNumberChapter = chapter;
                    isPageNumberFound = pageNumber;
                    return;
                }
            } else if (isNormalNumber) {
                let pgNum = Number(pageNumber);
                if (chapter.subChapters) {
                    chapter.subChapters.map(subChapter => {
                        let endPgNum = Number(subChapter.chapterEndPageNumber),
                            startPgNum = Number(subChapter.chapterStartPageNumber);
                        if (pgNum >= startPgNum && pgNum <= endPgNum) {
                            isPageNumberChapter = subChapter;
                            isPageNumberFound = pageNumber;
                            return;
                        }
                    });
                    if (chapter.pageHtmlLocation) {
                        let endPgNum = Number(chapter.chapterEndPageNumber),
                            startPgNum = Number(chapter.chapterStartPageNumber);
                        if (pgNum >= startPgNum && pgNum <= endPgNum) {
                            isPageNumberChapter = chapter;
                            isPageNumberFound = pageNumber;
                            return;
                        }
                    }
                } else {
                    let endPgNum = Number(chapter.chapterEndPageNumber),
                        startPgNum = Number(chapter.chapterStartPageNumber);
                    if (pgNum >= startPgNum && pgNum <= endPgNum) {
                        isPageNumberChapter = chapter;
                        isPageNumberFound = pageNumber;
                        return;
                    }
                }
            }
        });
        if (isPageNumberFound) { handleChapterSelection(isPageNumberChapter, isPageNumberFound); }
        else { setNoChaptDownlError({ popStatus: true, popMsg: "Error: This section of the eBook is not currently included for offline use. When you have an internet connection, make sure this section is selected, then regenerate your offline link." }) }
    }
    const handleGotoPage = (e) => {
        if (e.target.getAttribute("onClick") && e.target.getAttribute("onClick").includes("handleGotoPage(")) {
            let pageNumb = e.target.getAttribute("onClick").replaceAll("handleGotoPage(", "").replaceAll("\'", "").replaceAll(";", "").replaceAll(")", "")
            if (pageNumb) { navigateToPage(pageNumb) }
        } else if (e.target.parentNode.getAttribute("onClick") && e.target.parentNode.getAttribute("onClick").includes("handleGotoPage(")) {
            let pageNumb = e.target.parentNode.getAttribute("onClick").replaceAll("handleGotoPage(", "").replaceAll("\'", "").replaceAll(";", "").replaceAll(")", "");
            if (pageNumb) { navigateToPage(pageNumb); }
        } else if (e.target.getAttribute("onClick") &&
            (e.target.getAttribute("onClick").includes("EPub.showBCVideo(")
                || e.target.getAttribute("onClick").includes("EPub.showVimeoVideo("))) {
            setNoChaptDownlError({ popStatus: true, popMsg: "Error: Videos are unavailable while offline. Please connect to the internet to watch this video." })
        }
    }
    const getAndUpdateHighlightOneBook = async (chapterId) => {
        const highlightsVoList = await getChapterHighlights(chapterId, idbDetails);
        if (!highlightsVoList) { return false; }
        for (let j = 0; j < highlightsVoList.length; j++) {
            highlightParas(highlightsVoList[j], "highlight");
            displayNotes(highlightsVoList[j], "highlight");
        }
    }
    const getAndUpdateChapterProfLinkOneBook = async (chapterId) => {
        const profLinksVoList = await getChapterProfLinks(chapterId, idbDetails);
        if (!profLinksVoList) { return false; }
        for (let j = 0; j < profLinksVoList.length; j++) {
            highlightParas(profLinksVoList[j], "anchortag");
            displayNotes(profLinksVoList[j], "anchortag");
        }
    }
    const highlightParas = (annotationVO, type) => {
        // if annotation in single paragraph
        if (annotationVO.highlightStartParaId === annotationVO.highlightEndParaId) {
            highlightElement(annotationVO, annotationVO.highlightStartParaId, annotationVO.highlightParaStartOffset, annotationVO.highlightParaEndOffset, "single", type);
            return false;
        }
        // if annotation in multi paragraph.
        let paraList = annotationVO.enclosingParaList;
        for (let r = 0; r < paraList.length; r++) {
            if (r === 0) {
                highlightElement(annotationVO, paraList[r], annotationVO.highlightParaStartOffset, annotationVO.highlightParaEndOffset, "startPara", type, r);
            } else if (r === paraList.length - 1) {
                highlightElement(annotationVO, paraList[r], annotationVO.highlightParaStartOffset, annotationVO.highlightParaEndOffset, "endPara", type, r);
            } else {
                highlightElement(annotationVO, paraList[r], annotationVO.highlightParaStartOffset, annotationVO.highlightParaEndOffset, "fullPara", type, r);
            }
        }
    }
    const highlightElement = (annotationVO, paraId, startOffset, endOffset, paraType, type, r) => {
        const element = document.getElementById(paraId);
        let textNodeList = textNodesUnder(element)
        let takeHighlight = true
        let firstSubHighlight = true
        let highlightIconFlag = true;
        let charCount = 0;
        let ccHighLightStartOffset = 0;
        let ccHighLightEndOffset = 0;
        let currHighlightedCount = 0;
        for (let i = 0; i < textNodeList.length; i++) {
            if (takeHighlight) {
                let textNodeEndOffset = textNodeList[i].textContent.replace(/(\r\n|\n|\r)/gm, "").replace(/amp;/g, "").replace(/&nbsp;/g, ' ').length;
                if (paraType === "endPara" || paraType === "fullPara")
                    ccHighLightStartOffset = 0;
                else {
                    if (charCount + textNodeEndOffset < startOffset) {
                        charCount = charCount + textNodeEndOffset;
                        continue;
                    }
                }
                if (paraType === "endPara" || paraType === "fullPara") {
                    ccHighLightStartOffset = 0;
                } else {
                    if (firstSubHighlight) {
                        startOffset = parseFloat(startOffset)
                        if (startOffset < 0) ccHighLightStartOffset = charCount;
                        else if (parseFloat(startOffset) === 0 && charCount === 0) ccHighLightStartOffset = 0;
                        else ccHighLightStartOffset = startOffset - charCount;
                        firstSubHighlight = false;
                    }
                    else {
                        ccHighLightStartOffset = 0;
                    }
                }
                if (paraType === "startPara" || paraType === "fullPara") {
                    ccHighLightEndOffset = textNodeEndOffset;
                } else {
                    if (charCount + textNodeEndOffset < endOffset) {
                        ccHighLightEndOffset = textNodeEndOffset;
                    } else {
                        ccHighLightEndOffset = endOffset - charCount;
                        takeHighlight = false;
                    }
                }
                // fall back bad fix
                if (ccHighLightEndOffset > textNodeEndOffset)
                    ccHighLightEndOffset = textNodeEndOffset;
                try {
                    let range = document.createRange()
                    range.setStart(textNodeList[i], ccHighLightStartOffset)
                    range.setEnd(textNodeList[i], ccHighLightEndOffset)
                    let myHighlightWrapper = "";
                    switch (type) {
                        case 'highlight':
                            myHighlightWrapper = document.createElement("highlight");
                            myHighlightWrapper.setAttribute('class', 'highlightedText');
                            myHighlightWrapper.setAttribute('highlightParaStartOffset', annotationVO.highlightParaStartOffset);
                            myHighlightWrapper.setAttribute('highlightParaEndOffset', annotationVO.highlightParaEndOffset);
                            myHighlightWrapper.setAttribute('startOffset', annotationVO.highlightStartOffset);
                            myHighlightWrapper.setAttribute('endOffset', annotationVO.highlightEndOffset);
                            myHighlightWrapper.setAttribute('highlightStartParaId', annotationVO.highlightStartParaId);
                            myHighlightWrapper.setAttribute('highlightEndParaId', annotationVO.highlightEndParaId);
                            if (annotationVO.noteText !== undefined && annotationVO.noteText !== null) {
                                myHighlightWrapper.setAttribute('noteText', annotationVO.noteText);
                            }
                            else { myHighlightWrapper.setAttribute('noteText', " "); }
                            if (annotationVO.sectionId !== undefined && annotationVO.sectionId !== null) {
                                myHighlightWrapper.setAttribute('sectionId', annotationVO.sectionId);
                            }
                            else { myHighlightWrapper.setAttribute('sectionId', " "); }
                            myHighlightWrapper.setAttribute('hid', annotationVO.annotationId)
                            break;
                        case 'briefstag':
                            myHighlightWrapper = document.createElement("briefstag");
                            myHighlightWrapper.setAttribute('class', 'briefElementText');
                            myHighlightWrapper.setAttribute('briefParastartOffset', annotationVO.highlightParaStartOffset);
                            myHighlightWrapper.setAttribute('briefParaEndOffset', annotationVO.highlightParaEndOffset);
                            myHighlightWrapper.setAttribute('briefStartOffset', annotationVO.highlightStartOffset);
                            myHighlightWrapper.setAttribute('briefEndOffset', annotationVO.highlightEndOffset);
                            myHighlightWrapper.setAttribute('briefStartParaId', annotationVO.highlightStartParaId);
                            myHighlightWrapper.setAttribute('briefEndParaId', annotationVO.highlightEndParaId);
                            if (annotationVO.noteText !== undefined && annotationVO.noteText !== null) {
                                myHighlightWrapper.setAttribute('briefnote', annotationVO.noteText);
                            }
                            else { myHighlightWrapper.setAttribute('briefnote', " "); }
                            if (annotationVO.sectionId !== undefined && annotationVO.sectionId !== null) {
                                myHighlightWrapper.setAttribute('sectionId', annotationVO.sectionId);
                            }
                            else { myHighlightWrapper.setAttribute('sectionId', " "); }
                            myHighlightWrapper.setAttribute('bid', annotationVO.annotationId)
                            break;
                        case 'anchortag':
                            myHighlightWrapper = document.createElement("anchortag");
                            myHighlightWrapper.setAttribute('class', 'anchorElementText');
                            myHighlightWrapper.setAttribute('createdlinkurl', annotationVO.linkUrl);
                            myHighlightWrapper.setAttribute('createdlinkcomments', annotationVO.linkDescription);
                            myHighlightWrapper.setAttribute('linkeditingforproffessor', annotationVO.linkEditFlag);
                            myHighlightWrapper.setAttribute('createdlinksharestatus', annotationVO.linkShareFlag);
                            myHighlightWrapper.setAttribute('linkparastartoffset', annotationVO.highlightParaStartOffset);
                            myHighlightWrapper.setAttribute('linkparaendoffset', annotationVO.highlightParaEndOffset);
                            myHighlightWrapper.setAttribute('linkstartoffset', annotationVO.linkStartOffset);
                            myHighlightWrapper.setAttribute('linkendoffset', annotationVO.linkEndOffset);
                            myHighlightWrapper.setAttribute('linkstartparaid', annotationVO.highlightStartParaId);
                            myHighlightWrapper.setAttribute('linkendparaid', annotationVO.highlightEndParaId);
                            myHighlightWrapper.setAttribute('linkBackGroundColorCode', annotationVO.linkBackGroundColorCode);
                            if (annotationVO.sectionId !== undefined && annotationVO.sectionId !== null) {
                                myHighlightWrapper.setAttribute('sectionId', annotationVO.sectionId);
                            }
                            else { myHighlightWrapper.setAttribute('sectionId', " "); }
                            myHighlightWrapper.setAttribute('aid', annotationVO.annotationId)
                            break;
                    }
                    let myHighlightWrapperId = "";
                    if (paraType === "single") {
                        myHighlightWrapper.id = annotationVO.annotationId;
                        myHighlightWrapperId = annotationVO.annotationId;
                    }
                    else if (paraType === "startPara") {
                        myHighlightWrapper.id = annotationVO.annotationId;
                        myHighlightWrapperId = annotationVO.annotationId;
                    }
                    else if (paraType === "endPara" || paraType === "fullPara") {
                        myHighlightWrapper.id = annotationVO.annotationId + "_" + r;
                        myHighlightWrapperId = annotationVO.annotationId + "_" + r;
                    }
                    enclosingParaIdString = "";
                    if (annotationVO.enclosingParaList !== null && annotationVO.enclosingParaList !== undefined) {
                        let enclosingArray = [];
                        if (typeof (annotationVO.enclosingParaList) == "string")
                            enclosingParaIdString = annotationVO.highlightStartParaId;
                        else {
                            for (let paraIdIndex = 0; paraIdIndex < annotationVO.enclosingParaList.length; paraIdIndex++) {
                                let deEliminator = (paraIdIndex === annotationVO.enclosingParaList.length - 1) ? "" : "|";
                                enclosingParaIdString += annotationVO.enclosingParaList[paraIdIndex] + deEliminator;
                            }
                        }
                    }
                    myHighlightWrapper.setAttribute('enclosingParaIdString', enclosingParaIdString);
                    if (type === "anchortag") {
                        if (userVO) {
                            if (userVO.userRole === "Professor") {
                                if (annotationVO.linkBackGroundColorCode !== undefined) {
                                    annotationVO.linkBackGroundColorCode.toLowerCase() === "underline" ?
                                        myHighlightWrapper.style.cssText = 'text-decoration: underline;' :
                                        myHighlightWrapper.style.cssText = 'background-color: ' + annotationVO.linkBackGroundColorCode + ";";
                                }
                            }
                            else {
                                myHighlightWrapper.style.cssText = "border-bottom:3px dashed #757575";
                            }
                        }
                    } else {
                        if (annotationVO.highlightColorCode !== undefined) {
                            if (annotationVO.highlightColorCode.toLowerCase() === "underline") {
                                myHighlightWrapper.style.cssText = 'text-decoration: underline;';
                                myHighlightWrapper.setAttribute('colorCodeId', 'underLine');
                            }
                            else {
                                myHighlightWrapper.style.cssText = 'background-color: ' + annotationVO.highlightColorCode + ";";
                                myHighlightWrapper.setAttribute('colorCodeId', annotationVO.highlightColorCode);
                            }
                        }
                        let highlightIcon = document.createElement("span");
                        highlightIcon.style.cssText = 'height:15px; border:1px solid #CCCCCC; width:15px; position:absolute; right:0px;  background-color: ' + annotationVO.highlightColorCode + ";";
                    }
                    if (highlightIconFlag && (paraType === "startPara" || paraType === "single")) { }
                    let pem = new PrimitivoHighlighter(document.getElementById(paraId));
                    let arr = pem.highlightRange(range, myHighlightWrapper);
                    currHighlightedCount = currHighlightedCount + (ccHighLightEndOffset - ccHighLightStartOffset);
                    removeHighlightFromPageNumbers();
                    if (highlightIconFlag && arr.length > 0)
                        highlightIconFlag = false;
                    charCount = charCount + textNodeEndOffset;
                } catch (e) {
                    console.error("There has been a problem", e);
                }
            }
        }
    }
    const removeHighlightFromPageNumbers = () => {
        let highlightTags = document.getElementsByTagName("highlight");
        let linkTags = document.getElementsByTagName("anchortag");
        let briefTags = document.getElementsByTagName("briefstag");
        if (highlightTags) {
            for (let i = 0; i < highlightTags.length; i++) {
                if (highlightTags[i].parentNode.tagName.toLowerCase() === "span") {
                    if (highlightTags[i].parentNode.classList.contains("cc-pagenum-begin")) {
                        highlightTags[i].parentNode.innerHTML = highlightTags[i].textContent;
                    }
                }
            }
        }
        if (linkTags) {
            for (let i = 0; i < linkTags.length; i++) {
                if (linkTags[i].parentNode.tagName.toLowerCase() === "span") {
                    if (linkTags[i].parentNode.classList.contains("cc-pagenum-begin")) {
                        linkTags[i].parentNode.innerHTML = linkTags[i].textContent;
                    }
                }
            }
        }
        if (briefTags) {
            for (let i = 0; i < briefTags.length; i++) {
                if (briefTags[i].parentNode.tagName.toLowerCase() === "span") {
                    if (briefTags[i].parentNode.classList.contains("cc-pagenum-begin")) {
                        briefTags[i].parentNode.innerHTML = briefTags[i].textContent;
                    }
                }
            }
        }
    }
    const textNodesUnder = (el) => {
        let n, a = [], childEle = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        while (n = childEle.nextNode()) a.push(n);
        return a;
    }
    const highLightSelection = (newPlacement) => {
        setCopiedText("");
        setIsCopyOnlyPopoverOpen(false);
        if (window.getSelection) {
            selection = window.getSelection();
        } else if (typeof document.selection !== "undefined") {
            selection = document.selection;
        }
        if (selection.toString().length < 0 || selection.toString() === "") {
            return false;
        }
        setPlacement(newPlacement);
        setCopySelectedText(selection.toString());
        let selectionHTML = getSelectionHtml();
        // By selecting text create new tag at start of position.
        let range = selection.getRangeAt(0);
        let highlight = document.createElement("highlight");
        highlight.setAttribute('class', 'copypopover_position');
        range.insertNode(highlight);
        setAnchorEl(selectionHTML);
        showCopyPopoverAfterHighLight("copypopover_position");
        setIsCopyOnlyPopoverOpen(true);
    }
    const getSelectionHtml = () => {
        let html = "";
        if (typeof window.getSelection != "undefined") {
            let sel = window.getSelection();
            if (sel.rangeCount) {
                let container = document.createElement("div");
                for (let i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;
            }
        } else if (typeof document.selection != "undefined") {
            if (document.selection.type == "Text") {
                html = document.selection.createRange().htmlText;
            }
        }
        return html;
    }
    const showCopyPopoverAfterHighLight = (tagName) => {
        const htmlElementt = document.getElementsByClassName(tagName).item(0)
        if (htmlElementt) {
            htmlElementt.setAttribute("id", "highlightId");
            selectionElement = document.getElementById("highlightId");
            setAnchorEl(selectionElement);
        }
    }
    const handleClickAwayFromPopover = () => {
        setCopiedText("");
        // Remove copypopover element from content.
        const e = document.querySelectorAll(".copypopover_position");
        e.forEach(box => { box.remove(); });
        setIsCopyOnlyPopoverOpen(false);
    }
    function copyTextWithStyles() {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const clonedSelection = range.cloneContents();
        const div = document.createElement('div');
        div.appendChild(clonedSelection);
        const textWithStyle = div.textContent;
        navigator.clipboard.writeText(textWithStyle);
        setCopiedText(textWithStyle);
    }
    const displayNotes = (annotationVO, tagvalue) => {
        let dppAnotationId = annotationVO.annotationId;
        if (!document.getElementById(dppAnotationId)) {
            return false;
        }
        let element = document.getElementById(dppAnotationId);
        let rect = element.getBoundingClientRect();
        let yValue = rect.top;
        switch (tagvalue) {
            case 'anchortag':
                if (annotationVO.linkUrl && userVO) {
                    if (userVO.userRole === "Student") {
                        displayLinksOnLeft(dppAnotationId, yValue, annotationVO.linkUrl, annotationVO.linkDescription, annotationVO.linkShareFlag, annotationVO.linkEditFlag);
                    } else if (userVO.userRole === "Professor") {
                        if (annotationVO.linkShareFlag === "true") {
                            displayLinksOnLeft(dppAnotationId, yValue, annotationVO.linkUrl, annotationVO.linkDescription, annotationVO.linkShareFlag, annotationVO.linkEditFlag);
                        } else if (annotationVO.linkShareFlag === "false") {
                            displayNotesOnRight(annotationVO.linkDescription, dppAnotationId, yValue, annotationVO.linkBackGroundColorCode, true);
                        }
                    }
                }
                break;
            case 'highlight':
                if (annotationVO.noteText) {
                    displayNotesOnRight(annotationVO.noteText.replace(/</g, "&lt;").replace(/>/g, "&gt;"), dppAnotationId, yValue, annotationVO.highlightColorCode, false);
                }
                break;
        }
    }
    const displayNotesOnRight = (noteText, noteId, topValue, boxColor, isLink) => {
        let allNotes = "";
        if (document.querySelector("#anchorElement" + noteId)) {
            document.querySelector("#anchorElement" + noteId).remove();
        }
        let containerTop = document.getElementById('notes-container').getBoundingClientRect().top;
        //Creating a dynamic div and span
        let clickableAnchorElement = document.createElement('A');
        clickableAnchorElement.id = 'anchorElement' + noteId;
        clickableAnchorElement.setAttribute('noteText', noteText);
        clickableAnchorElement.setAttribute('aria-label', noteText);
        clickableAnchorElement.style.color = '#333333';
        if (boxColor !== undefined) {
            clickableAnchorElement.setAttribute('colorcodeid', boxColor);
        }
        let notesText = document.createElement('div');
        notesText.id = 'notesDiv' + noteId;
        notesText.className = "notesText";
        notesText.style.top = (topValue - containerTop - 2) + "px";
        if (noteText !== "" && noteText !== null && noteText !== undefined) {
            notesText.innerHTML = noteText;
            notesText.title = noteText;
            if ((noteText.length > 40 && noteText.split(" ").length < 5) || (noteText.length > 40 && noteText.split(" ")[0].length > 20) || (noteText.length > 25 && noteText.split(" ")[0].length > 20)) {
                notesText.className = "notesText overlapCheckClass  ellipsis";
                notesText.style.width = "150px";
            } else {
                notesText.className = "notesText overlapCheckClass";
            }
        }
        let iconOverValue = 5;
        let notesColor = document.createElement('span');
        notesColor.id = noteId;
        notesColor.className = "notesSpanBlock";
        notesColor.setAttribute('style', 'background-color:' + boxColor + ' !important;' + ' top:' + (topValue - containerTop) + "px" + ';');
        allNotes = document.querySelectorAll('.notesText');
        let i;
        let lastNoteTopValue = 0;
        let lastNoteHeight = 0;
        let IconTopValue = topValue - containerTop + "px";
        if (allNotes !== null && allNotes.length !== 0 && allNotes.length !== undefined) {
            for (i = 0; i < allNotes.length; i++) {
                lastNoteHeight = allNotes[i].offsetHeight + iconOverValue;
                if (parseInt(allNotes[i].style.top) == parseInt(notesText.style.top)) {
                    lastNoteTopValue = parseInt(allNotes[i].style.top);
                    notesText.style.top = parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
                    notesColor.style.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    IconTopValue = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    clickableAnchorElement.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                } else if ((parseInt(allNotes[i].style.top) < (parseInt(notesText.style.top) + lastNoteHeight)) && (parseInt(allNotes[i].style.top) > (parseInt(notesText.style.top) - lastNoteHeight))) {
                    if (parseInt(allNotes[i].style.top) > lastNoteTopValue) {
                        lastNoteTopValue = parseInt(allNotes[i].style.top);
                        notesText.style.top = parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
                        notesColor.style.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                        IconTopValue = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                        clickableAnchorElement.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    }
                }
            }
        }
        document.getElementById('notes-container').appendChild(clickableAnchorElement);
        if (isLink === true) {
            ReactDOM.render(<i className="fas fa-link linkIcon" style={{ top: IconTopValue }} />, document.getElementById(clickableAnchorElement.id));
        } else {
            ReactDOM.render(<i className="far fa-file-alt notesIcon" style={{ top: IconTopValue }} />, document.getElementById(clickableAnchorElement.id));
        }
        clickableAnchorElement.appendChild(notesText);
        // By clicking note icon annotation popover is open/
        if (isLink === true) {
            clickableAnchorElement.setAttribute('linkcomments', boxColor);
            document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) {
                linkNoteTextClicked(e);
            });
        }
        else {
            document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) {
                noteTextClicked(e);
            });
        }
    }
    const displayLinksOnLeft = (linkId, topValue, urlText, urlComment, checkboxStatus, linkEditingForproffessor) => {
        if (document.getElementById("linkAnchorElement" + linkId)) {
            document.getElementById("linkAnchorElement" + linkId).remove();
        }
        let containerTop = document.getElementById('links-container').getBoundingClientRect().top;
        let clickableAnchorElement = document.createElement('A');
        clickableAnchorElement.id = 'linkAnchorElement' + linkId;
        let linkIcon = document.createElement('IMG');
        linkIcon.className = "linksIcon display-inline-block";
        linkIcon.style.top = (topValue - containerTop - 2) + "px";
        linkIcon.src = shareLinkIcon;
        linkIcon.style.width = '25px';
        linkIcon.style.height = 'auto';
        linkIcon.style.position = 'absolute';
        linkIcon.setAttribute("urlText", urlText);
        linkIcon.setAttribute("shareLinkChecked", checkboxStatus);
        linkIcon.setAttribute("linkEditingForproffessor", linkEditingForproffessor);
        let linkText = document.createElement('div');
        linkText.id = 'linkDiv' + linkId;
        linkText.style.top = (topValue - containerTop - 2) + "px";
        linkText.className = "linksIcon linksText";
        linkText.style.right = "70px";
        if (urlComment !== "" && urlComment !== null && urlComment !== undefined) {
            if ((urlComment.length > 40 && urlComment.split(" ").length < 5) || (urlComment.length > 40 && urlComment.split(" ")[0].length > 20) || (urlComment.length > 25 && urlComment.split(" ")[0].length > 20)) {
                linkText.className = "linksIcon linksText overlapCheckClass  ellipsis";
                linkText.style.width = "150px";
            } else {
                linkText.className = "linksIcon linksText overlapCheckClass";
            }
        } else {
            linkText.className = "linksIcon linksText";
        }
        let iconOverValueL = 15;
        if (urlComment !== undefined && urlComment !== null && urlComment !== "") {
            linkText.innerHTML = urlComment;
            linkText.title = urlComment;
            linkIcon.setAttribute("urlComments", urlComment.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
        }
        else { linkIcon.setAttribute("urlComments", ""); }
        let allLinks = $('.linksText');
        allLinks.sort(function (a, b) {
            if (a.style.top > b.style.top)
                return 1;
            if (a.style.top < b.style.top
            )
                return -1;
            // a must be equal to b
            return 0;
        });
        let i;
        let lastNoteHeight = 0;
        let lastNoteTopValue = 0;
        for (i = 0; i < allLinks.length; i++) {
            lastNoteHeight = allLinks[i].offsetHeight + iconOverValueL;
            if (parseInt(allLinks[i].style.top) == parseInt(linkIcon.style.top)) {
                lastNoteTopValue = parseInt(allLinks[i].style.top);
                linkIcon.style.top = parseInt(allLinks[i].style.top) - 2 + lastNoteHeight + "px";
                linkText.style.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
                clickableAnchorElement.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
                //document.getElementById(allLinks[i].id).parentElement.firstChild.remove();
            }
            else if ((parseInt(allLinks[i].style.top) < (parseInt(linkIcon.style.top) + parseInt(lastNoteHeight))) && (parseInt(allLinks[i].style.top) > (parseInt(linkIcon.style.top) - parseInt(lastNoteHeight)))) {
                if (parseInt(allLinks[i].style.top) > lastNoteTopValue) {
                    lastNoteTopValue = parseInt(allLinks[i].style.top);
                    linkIcon.style.top = parseInt(allLinks[i].style.top) + 7 + parseInt(lastNoteHeight) + "px";
                    linkText.style.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
                    clickableAnchorElement.top = parseInt(allLinks[i].style.top) + parseInt(lastNoteHeight) + "px";
                }
            }
        }
        clickableAnchorElement.appendChild(linkIcon);
        clickableAnchorElement.appendChild(linkText);
        document.getElementById('links-container').appendChild(clickableAnchorElement);
        document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) {
            linkSharedTextClicked(e);
        });
        let allrTsIcon = $('.rTsIcon');
        for (let j = 0; j < allrTsIcon.length; j++) {
            let differenceInTop = 0;
            if (parseInt(linkIcon.style.top) >= parseInt(allrTsIcon[j].style.top)) {
                differenceInTop = parseInt(linkIcon.style.top) - parseInt(allrTsIcon[j].style.top);
                if (differenceInTop < 20) {
                    allrTsIcon[j].remove();
                    allrTsIcon[j].style.top = parseInt(linkIcon.style.top) + 7 + parseInt(lastNoteHeight) + "px";
                    document.getElementById('links-container').appendChild(allrTsIcon[j]);
                }
            }
        }
        let currentAnnotationRect = document.getElementById('linkDiv' + linkId).getBoundingClientRect();
        let fetchedAnnotationRect = null;
        for (i = 0; i < allLinks.length; i++) {
            fetchedAnnotationRect = document.getElementById(allLinks[i].id).getBoundingClientRect();
            if (!(currentAnnotationRect.right < fetchedAnnotationRect.left ||
                currentAnnotationRect.left > fetchedAnnotationRect.right ||
                currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
                currentAnnotationRect.top > fetchedAnnotationRect.bottom)) {
            }
        }
    }
    const linkSharedTextClicked = (e) => {
        selectedNoteId = e.currentTarget.id;
        selectedNoteId = selectedNoteId.substring(17, selectedNoteId.length);
        setIsPopoverOpenUpdate(true)
        let selectedNoteIdUpdate = (typeof selectedNoteId === "string") ? selectedNoteId : selectedNoteId.currentTarget.getAttribute("hid");
        setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate));
        let existingNoteValue = document.getElementById(selectedNoteIdUpdate) ? (document.getElementById(selectedNoteIdUpdate).getAttribute('createdlinkcomments') != 'undefined' ? document.getElementById(selectedNoteIdUpdate).getAttribute('createdlinkcomments').trim() : '') : "";
        setNoteValue(existingNoteValue);
        let existingLink = document.getElementById(selectedNoteIdUpdate).getAttribute("createdlinkurl").trim();
        if (existingLink !== "" && existingLink !== undefined) { setProflink(existingLink); }
        setShowLink(true);
        setPlacementUpdate('bottom');
    }
    const linkNoteTextClicked = (e) => {
        selectedNoteId = e.currentTarget.id;
        selectedNoteId = selectedNoteId.substring(13, selectedNoteId.length);
        setIsPopoverOpenUpdate(true)
        let selectedNoteIdUpdate = (typeof selectedNoteId === "string") ? selectedNoteId : selectedNoteId.currentTarget.getAttribute("hid");
        setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate));
        let existingNoteValue = document.getElementById(selectedNoteIdUpdate) ? (document.getElementById(selectedNoteIdUpdate).getAttribute('createdlinkcomments') != 'undefined' ? document.getElementById(selectedNoteIdUpdate).getAttribute('createdlinkcomments').trim() : '') : "";
        setNoteValue(existingNoteValue);
        let existingLink = document.getElementById(selectedNoteIdUpdate).getAttribute("createdlinkurl").trim();
        if (existingLink !== "" && existingLink !== undefined) { setProflink(existingLink); }
        setShowLink(true);
        setPlacementUpdate('bottom');
    }
    const noteTextClicked = (e) => {
        selectedNoteId = e.currentTarget.id;
        selectedNoteId = selectedNoteId.substring(13, selectedNoteId.length);
        setIsPopoverOpenUpdate(true)
        let selectedNoteIdUpdate = (typeof selectedNoteId === "string") ? selectedNoteId : selectedNoteId.currentTarget.getAttribute("hid");
        setAnchorElUpdate(document.getElementById(selectedNoteIdUpdate));
        let existingNoteValue = document.getElementById(selectedNoteIdUpdate) ? (document.getElementById(selectedNoteIdUpdate).getAttribute("noteText") ? document.getElementById(selectedNoteIdUpdate).getAttribute("noteText").trim() : "") : ""
        setNoteValue(existingNoteValue);
        setShowLink(false);
        setPlacementUpdate('bottom');
    }
    const handleClickAwayFromPopoverUpdate = () => {
        setIsPopoverOpenUpdate(false);
        setNoteValue("");
        setProflink("");
        setShowLink(true);
    }
    return (
        <React.Fragment>
            <div className="offlineReader">
                <Header pageName="offlineRead"></Header>
                {
                    downlChapterList && downlChapterList.length ?
                        <>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                <div id="offlineReader-BlueStripContainer" className="offlineReader-BlueStrip" label="toolbar" aria-label="toolbar">
                                    <Navbar collapseOnSelect expand="lg" aria-label="toolbar">
                                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                        <Navbar.Collapse id="responsive-navbar-nav">
                                            <Nav className="mr-auto offlineReader-navBarFontSize" onClick={() => setIsNavSubMenuOpen(!isNavSubMenuOpen)}>
                                                <NavDropdownMenu title="Contents" show={isNavSubMenuOpen}>
                                                    <div className="offlineReader-navBarScrollBlock">
                                                        {
                                                            downlChapterList && downlChapterList.map((chapter) => {
                                                                return (
                                                                    chapter.subChapters ?
                                                                        <DropdownSubmenu href='javascript:void(0)' key={chapter.chapterId} title={
                                                                            <div className='row m-0'>
                                                                                <span className='offlineReader-menuTitle col-10 no-padding' onClick={() => handleChapterChariotDown(chapter, 'chapterName', !chapter.chariot_down_status)}>
                                                                                    {chapter.navbarTitle}
                                                                                </span>
                                                                                <span className='offlineReader-menuTitle col-2 no-padding' onClick={() => handleChapterChariotDown(chapter, 'chapterCaretIcon', !chapter.chariot_down_status)}>
                                                                                    {
                                                                                        chapter.chariot_down_status ?
                                                                                            <AiFillCaretDown data-testid={`chariotDown_${chapter.chapterId}`} className="offlineReader-faAngleDown_rt pull-right" /> :
                                                                                            <AiFillCaretRight data-testid={`chariotRight_${chapter.chapterId}`} className="offlineReader-faAngleRight_rt pull-right" />
                                                                                    }
                                                                                </span>
                                                                            </div>}>
                                                                            <div className='offlineReader-subMenu'>
                                                                                {
                                                                                    chapter.subChapters.map(subChapter => {
                                                                                        return (
                                                                                            <NavDropdown.Item key={subChapter.chapterId} className='no-padding' onClick={() => handleChapterSelection(subChapter, undefined, chapter.chapterId)}>
                                                                                                <span>{subChapter.navbarTitle}</span>
                                                                                            </NavDropdown.Item>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </DropdownSubmenu> :
                                                                        <NavDropdown.Item key={chapter.chapterId} onClick={() => handleChapterSelection(chapter)}>
                                                                            {chapter.navbarTitle}
                                                                        </NavDropdown.Item>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </NavDropdownMenu>
                                            </Nav>
                                        </Navbar.Collapse>
                                    </Navbar>
                                </div>
                            </div>
                            <div className={classes.root}>
                                <Popper
                                    placement={'bottom'} disablePortal={false} transition
                                    id={copyId} open={isCopyOnlyPopoverOpen} anchorEl={anchorEl}
                                    container={document.getElementById('offlineReader-ereaderContainer')}
                                    modifiers={{ flip: { enabled: true }, preventOverflow: { enabled: true, boundariesElement: 'scrollParent' } }}
                                >
                                    {({ TransitionProps }) => (
                                        <ClickAwayListener onClickAway={handleClickAwayFromPopover}>
                                            <Fade {...TransitionProps} timeout={350}>
                                                <Paper>
                                                    <Typography className={classes.typography}>
                                                        <div className="hlPopover" rel="popover" data-trigger="focus">
                                                            <div className="highlight-popover" id="highlight-popover">
                                                                <CopyToClipboard text={copySelectedText}>
                                                                    <button className="highlightCopy-labelBlue" style={{ border: "0", padding: "0" }}
                                                                        onClick={copyTextWithStyles}>Copy Text {copiedText !== "" ? <FontAwesomeIcon icon={faCheck} className="TickIcon" /> : null}</button>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>
                                                    </Typography>
                                                </Paper>
                                            </Fade>
                                        </ClickAwayListener>
                                    )}
                                </Popper>
                            </div>
                            {/* Annotation popover html start */}
                            <div className={classes.root}>
                                <Popper
                                    id={'simple-popover'} open={isPopoverOpenUpdate} anchorEl={anchorElUpdate} container={document.getElementById('ereader-container')} placement={placementUpdate} disablePortal={false} transition
                                    modifiers={{ flip: { enabled: true, }, preventOverflow: { enabled: true, boundariesElement: 'scrollParent' }, }}
                                >
                                    {({ TransitionProps }) => (
                                        <ClickAwayListener onClickAway={handleClickAwayFromPopoverUpdate}>
                                            <Fade {...TransitionProps} timeout={350}>
                                                <Paper>
                                                    <Typography className={classes.typography}>
                                                        <div className="hlPopover" rel="popover" data-trigger="focus">
                                                            <div className="highlight-popover" id="highlightUpdate-popover">
                                                                <div className="highlight-label">Annotate</div>
                                                                <div id="highlighter-notes">
                                                                    <div className="note-edit-container">
                                                                        <textarea id="edit-note-text-area" className="note-text-area" name="noteValue" value={noteValue} readOnly></textarea>
                                                                    </div>
                                                                </div>
                                                                {showLink ?
                                                                    <>
                                                                        <div className="highlight-label">Link</div>
                                                                        <div id="highlighter-link">
                                                                            <input id="Proflink" className="Proflink" name="Proflink" value={profLink} readOnly ></input>
                                                                        </div>
                                                                    </> : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </Typography>
                                                </Paper>
                                            </Fade>
                                        </ClickAwayListener>
                                    )}
                                </Popper>
                            </div>
                            {/* Annotation popover end start */}
                            {
                                downlSelChapter &&
                                <>
                                    <div className="offlineReader-indexHeader">
                                        <div className="ml-4 pl-2 pt-2 pb-1">
                                            <p className="offlineReader-bookTitle m-0">{bookDetails && bookDetails.bookTitle}</p>
                                            <p className="offlineReader-chapterTitle m-0">{downlSelChapter.navbarTitle}</p>
                                        </div>
                                    </div>
                                    <div data-testid="container" className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 no-padding" id="offlineReader-bookContentContainer" onScroll={() => handleScroll()}>
                                        <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mx-auto text-center no-padding">
                                            {
                                                downlSelChapCont &&
                                                <>
                                                    <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1  col-xs-1 mTopTen display-inline-block ereaderAnnotationBlock">
                                                        <div id="links-container" className="display-inline-block"></div>
                                                    </div>
                                                    <div className='col-xl-10 col-lg-10 col-md-10 col-sm-8  col-xs-10  mTopTen display-inline-block ereaderContentCenterSec'>
                                                        <div
                                                            id="offlineReader-ereaderContainer"
                                                            data-testid="offlineReader-ereaderContainer"
                                                            onClick={(e) => handleGotoPage(e)}
                                                            onMouseUp={() => highLightSelection('bottom')}
                                                            onKeyUp={() => highLightSelection('bottom')}
                                                            onTouchStart={() => highLightSelection('bottom')}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: downlSelChapCont }}></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 mTopTen display-inline-block ereaderAnnotationBlock">
                                                        <div id="notes-container" className="display-inline-block"></div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    {
                                        showNextChapterLink ?
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding nextChapterLink">
                                                <i className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 fas fa-arrow-right nextChapterLinkArrow"></i>
                                                <a className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding" href='javascript:void(0)' onClick={() => setIsNavSubMenuOpen(!isNavSubMenuOpen)}>Open the Contents Menu</a>
                                                <i data-testid="closeNextChapterLink" className="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 fa fa-close nextChapterLinkClose" onClick={() => setShowNextChapterLink(false)}></i>
                                            </div>
                                            : null
                                    }
                                </>
                            }
                        </> :
                        noDownlMsg.length > 0 ?
                            <div className="row offlineReader-noContBackGr">
                                <div className="col-xl-8 col-lg-8 col-md-10 col-sm-12 col-12  mx-auto text-center offlineReader-noContBase">
                                    <div className="offlineReader-noContBackGround">
                                        <div className="offlineReader-noContDiv">
                                            <div className='offlineReader-noContentHead'>Something went wrong</div>
                                            <p className="offlineReader-noContentMsg">{noDownlMsg}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> : null
                }
                <Modal show={noChaptDownlError.popStatus} onHide={() => setNoChaptDownlError({ popStatus: false, popMsg: "" })} aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="main-modals" contentClassName="offlineReader-errModalCont" className="modal fade" role="dialog" aria-hidden="true">
                    <div className="offlineReader-errModalBord">
                        <p data-testid="closeErrorModal" type="button" className="pull-right offlineReader-errModalClose" title="Close" aria-label="Close Window" data-dismiss="modal" onClick={() => setNoChaptDownlError({ popStatus: false, popMsg: "" })}></p>
                        <p className='p-2 m-0 offlineReader-errModalTxt'>{noChaptDownlError.popMsg}</p>
                    </div>
                </Modal>
            </div>
            <div className="offlineReaderPrintMsg">Printing is restricted while offline. Please connect to the internet to print pages from this title.</div>
        </React.Fragment>
    );
}
export default OfflineRead;